import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import TextSpinner from './TextSpinner';

const phrases = [
    [
        'Champ,',
        'Fact:',
        'Everybody says',
        'Dang...',
        'Check it:',
        'Just saying...',
        'Superstar,',
        'Tiger,',
        'Self,',
        'Know this:',
        'News alert:',
        'Girl,',
        'Ace,',
        'Excuse me but',
        'Experts agree:',
        'In my opinion,',
        'Hear ye, hear ye:',
        'Okay, listen up:'
    ],
    [
        'the mere idea of you',
        'your soul',
        'your hair today',
        'everything you do',
        'your personal style',
        'every thought you have',
        'that sparkle in your eye',
        'your presence here',
        'what you got going on',
        'the essential you',
        'your life\'s journey',
        'that saucy personality',
        'your DNA',
        'that brain of yours',
        'your choice of attire',
        'the way you roll',
        'whatever your secret is',
        'all of y\'all'
    ],
    [
        'has serious game,',
        'rains magic,',
        'deserves the Nobel Prize,',
        'raises the roof,',
        'breeds miracles,',
        'is paying off big time,',
        'shows mad skills,',
        'just shimmers,',
        'is a national treasure,',
        'gets the party hopping,',
        'is the next big thing,',
        'roars like a lion,',
        'is a rainbow factory,',
        'is made of diamonds,',
        'makes birds sing,',
        'should be taught in school,',
        'makes my world go \'round,',
        'is 100% legit,'
    ],
    [
        '24/7.',
        'can I get an amen?',
        'and that\'s a fact.',
        'so treat yourself.',
        'you feel me?',
        'that\'s just science.',
        'would I lie?',
        'for reals.',
        'mic drop.',
        'you hidden gem.',
        'snuggle bear.',
        'period.',
        'now let\'s dance.',
        'high five.',
        'say it again.',
        'according to CNN.',
        'so get used to it.'
    ]
];

const allPhrases = phrases[0].concat(phrases[1]).concat(phrases[2]).concat(phrases[3]);

class PhraseSpinners extends React.Component {
    constructor() {
        super();
        this.randomize();
    }

    randomize = () => {
        this.chosenPhrases = [0, 0, 0, 0];

        phrases.map((subPhrases, i) => {
            this.chosenPhrases[i] = subPhrases[Math.floor((Math.random() * subPhrases.length))];
        });

        this.setState(this.chosenPhrases);
    }

    getSanitizedPhrase = (phrase) => {
        return phrase.replace(/[^a-zA-Z0-9]/g, '');
    }

    render() {
        return (
            <Container fluid>
                <Row>
                    <Col xl={12}>
                        <div className="randomizeWrapper text-center">
                            <Button onClick={this.randomize} variant="outline-success" size="lg" className="text-center">
                                Pep me up!
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xl className="bits">
                        <Container fluid>
                            <Row>
                                {phrases.map((subPhrases, i) => {
                                    return <Col xl={3}><TextSpinner key={this.getSanitizedPhrase(this.chosenPhrases[i])} phrases={allPhrases} chosenPhrase={this.chosenPhrases[i]} /></Col>
                                })}
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default PhraseSpinners;